<template>
  <span v-html="replaceText(text)" />
</template>

<script>
export default {
  name: "RawHtml",
  props: {
    text: {
      type: String,
      required: false,
      default: ""
    }
  },
  methods: {
    replaceText(text) {
      if (!_.isString(this.text)) return ""

      let sanitized = this.$sanitize(text, {
        allowedAttributes: {
          "*": ["style"],
          a: ["href", "target", "class", "style"]
        },
        allowedStyles: {
          "*": {color: [/^#(0x)?[0-9a-f]+$/i, /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/, /^[a-zA-Z]+$/]}
        },
        allowedSchemes: ["https"],
        allowedSchemesByTag: {
          href: ["href"]
        },
        transformTags: {
          a: function(tagName, attribs) {
            return {
              tagName: "a",
              attribs: {
                href: attribs.href,
                class: "message_link",
                target: "_black"
              }
            }
          }
        }
      })

      // aタグが含まれないURLの場合リンクに変換
      sanitized = sanitized.replace(
        /(?![^<]*>|[^<>]*<\/)((https?:)\/\/[-_.!~*'()a-z0-9;/?:@&=+$,%#]+)/gi,
        "<a href='$1' class='message_link' target='_black'>$1</a>"
      )
      // 改行文字を<br>に変換し返却
      return sanitized.replace(/\n/g, "<br/>")
    }
  }
}
</script>
